import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var requestEarningsCalculation = createAction("".concat(actionKey, "/REQUEST_CALCULATION"), function (dollarPrice, productType) { return ({
    dollarPrice: dollarPrice,
    productType: productType,
}); });
export var requestEarningsCalculationSuccess = createAction("".concat(actionKey, "/REQUEST_CALCULATION_SUCCESS"), function (result) { return result; });
export var requestEarningsCalculationError = createAction("".concat(actionKey, "/REQUEST_CALCULATION_ERROR"), function (error) { return error; });
//# sourceMappingURL=actionCreators.js.map